import React from 'react';
import { isEditor } from '../../utils/isEditor.js';
import { LOAN_PROGRAMS } from '../../utils/zhl-calculator.js';
import CashOutRefinanceCalculator from './CashOutRefinanceCalculator.js';
import { FieldConfig } from './CashOutRefinanceCalculator.utils.js';

var _attributes;
var CashOutRefinanceCalculatorBlock = {
  Component: function Component(_ref) {
    var attrs = _ref.attrs;
    var homeValue = attrs.homeValue,
      currentMortgageBalance = attrs.currentMortgageBalance,
      newLoanTerm = attrs.newLoanTerm,
      newInterestRate = attrs.newInterestRate,
      adjustCashOutAmount = attrs.adjustCashOutAmount,
      fees = attrs.fees,
      rollFees = attrs.rollFees;
    var defaultValues = {
      homeValue: homeValue,
      currentMortgageBalance: currentMortgageBalance,
      newLoanTerm: newLoanTerm,
      newInterestRate: newInterestRate,
      adjustCashOutAmount: adjustCashOutAmount,
      fees: fees,
      rollFees: rollFees
    };
    return /*#__PURE__*/React.createElement(CashOutRefinanceCalculator, {
      key: isEditor() ? JSON.stringify(defaultValues) : undefined,
      defaultValues: defaultValues
    });
  },
  metadata: {
    version: '1.0',
    name: 'constellation/cashout-refinance-calculator',
    title: 'Cash-Out Refinance Calculator',
    description: 'Zillow`s cash-out refinance calculator can help you determine what your monthly payment would be and see if this loan is the right fit for your financial situation.',
    icon: 'money-alt',
    keywords: ['mortgages', 'calculators', 'cash', 'refinance'],
    supports: {
      customClassName: false,
      html: false
    },
    category: 'Calculators',
    attributes: (_attributes = {}, _attributes[FieldConfig.homeValue.name] = {
      type: 'number',
      default: 300000,
      label: 'Default home value',
      control: 'number'
    }, _attributes[FieldConfig.currentMortgageBalance.name] = {
      type: 'number',
      default: 10000,
      label: 'Default Mortgage balance',
      control: 'number'
    }, _attributes[FieldConfig.newInterestRate.name] = {
      type: 'number',
      label: 'Default new interest rate',
      default: 4.176,
      control: 'number'
    }, _attributes[FieldConfig.adjustCashOutAmount.name] = {
      type: 'number',
      label: 'Default adjust cash-out amount',
      default: 190000,
      control: 'number'
    }, _attributes[FieldConfig.newLoanTerm.name] = {
      type: 'string',
      default: LOAN_PROGRAMS.fixed0Year,
      label: 'Default current term',
      control: 'select',
      choices: FieldConfig.newLoanTerm.options
    }, _attributes[FieldConfig.fees.name] = {
      type: 'number',
      default: 1000,
      label: 'Default refinance fees',
      control: 'number'
    }, _attributes[FieldConfig.rollFees.name] = {
      type: 'boolean',
      default: 1000,
      label: 'Default roll fees',
      control: 'boolean'
    }, _attributes)
  }
};
var CashOutRefinanceCalculatorBlock$1 = CashOutRefinanceCalculatorBlock;

export { CashOutRefinanceCalculatorBlock$1 as default };
